'use client'
import { useState } from 'react';
import { Button, Modal } from '@mantine/core';

const GoogleCalendar = () => {
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title="Book a Demo"
        size={'96%'}
        centered
        overlayProps={{ blur: 3 }}
        styles={{
          body: { padding: 0 },
        }}
      >
        <iframe
          src={'https://calendar.google.com/calendar/appointments/schedules/AcZssZ0jd53nMLNxRvpagW5tb4YCW8OEgpw7gvnX0yIDC2UtIyb57_aSR9vGOvQ2mFfAiUOPTxD6Gu_T?gv=true'}
          width="100%"
          height="600"
          style={{ border: 'none' }}
          allowFullScreen
        />
      </Modal>

      <Button
        onClick={() => setOpened(true)}
        size='lg'
        bg='orange'
      >
        Book a Demo
      </Button>
    </>
  );
}

export default GoogleCalendar